export default "__VITE_ASSET__8adea7eb__"